import {MissionDao} from '../../dao';
import {ErrorModel, MissionModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';

const FUNCTION_CODE = 'GET_MISSION_BY_ID';

export async function updateMissionById(userData: Record<string, string>, updatedMission:Record<string, string>) {
    try {

        const mission = await MissionDao.updateMissionById(userData.userToken, updatedMission);

        const parsedMission = MissionModel.parseMission(mission);

        return parsedMission;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
